module.exports = __webpack_public_path__ + "static/media/Lovelo_Black.fca6bef8.otf";